<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
<!--            <el-tab-pane label="OKR排行" name="0">-->
<!--                <okrBank :sectionClassId="16"></okrBank>-->
<!--            </el-tab-pane>-->
            <el-tab-pane label="OKR查看" name="0">
                <okrList :sectionClassId="16"></okrList>
            </el-tab-pane>

            <el-tab-pane label="OKR" name="1">
                <okrForm :sectionClassId="16"></okrForm>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import cooperateForm from '@/components/cooperative/cooperativeForm'
    import okrList from '@/components/cooperative/okrList'
    import okrBank from "@/components/cooperative/okrBank"
    import okrForm from "@/components/cooperative/okrForm";
    //定义组件
    export default {
        data() {
            return {
                activeName:'0'
            }
        },
        components:{
            okrForm,
            okrBank,
            okrList

        },
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/OKR.vue